import { useState } from "react";
import { MotionConfig } from "framer-motion";

import Nav from "../Components/Nav/Nav";
import Hero from "../Components/Hero";
import AxisTester from "../Components/AxisTester";
import Features from "../Components/Features";
import InUse from "../Components/InUse";
import Plans from "../Components/Plans";
import Studio from "../Components/Studio";
import Contact from "../Components/Contact";
import Footer from "../Components/Footer/Footer";

export default function Home() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <MotionConfig reducedMotion="user">
      <div className="mx-auto box-border max-w-[1440px] px-5 sm:px-10 lg:px-16">
        <a
          href="#main-content"
          className="sr-only focus:not-sr-only focus:fixed focus:left-5 focus:top-5 focus:z-50 focus:bg-ink focus:px-[26px] focus:py-[14px] focus:font-mono focus:text-xs focus:uppercase focus:tracking-[0.1em] focus:text-paper"
        >
          Skip to content
        </a>

        <Nav isOpen={isMenuOpen} setIsOpen={setIsMenuOpen} />

        <div aria-hidden={isMenuOpen ? "true" : undefined} {...(isMenuOpen ? { inert: "" } : {})}>
          <main id="main-content">
            <Hero />
            <AxisTester />
            <Features />
            <InUse />
            <Plans />
            <Studio />
            <Contact />
          </main>
          <Footer />
        </div>
      </div>
    </MotionConfig>
  );
}
